import { SearchProps } from '~components/form-fields/search';

/**
 * Search definitions for the Payment Batches list. The status filter is left
 * as a free-text field for now — payment batch statuses are seeded from the
 * `lookup_gocardless_payment_batch_statuses` table by the API. The
 * standalone status-options endpoint is not yet wired up; until then the user
 * can filter by tag (e.g. "paid_out", "submitted") matching the API contract.
 */
export const searchFields: SearchProps = {
  search: {
    defaultShow: true,
    type: 'text-like',
    field: 'search',
    placeholder: 'Batch ID or description',
    caption: 'Search',
  },
  status: {
    defaultShow: true,
    type: 'text-like',
    field: 'status',
    placeholder: 'Status tag',
    caption: 'Status',
  },
};
